import * as yup from 'yup';
import {
  alphabetRegix
} from '../utils/functions';

export const individual_personal_information_validation_schema = yup.object().shape({
  titleId: yup
    .object()
    .required('title_is_required'),

  firstNameEnglish: yup
    .string()
    .matches(alphabetRegix, 'invalid_name')
    .required('first_name_is_required'),

  secondNameEnglish: yup
    .string()
    .matches(alphabetRegix, 'invalid_name')
    .required('second_name_is_required'),

  thirdNameEnglish: yup
    .string()
    .matches(alphabetRegix, 'invalid_name')
    .required('third_name_is_required'),

  lastNameEnglish: yup
    .string()
    .matches(alphabetRegix, 'invalid_name')
    .required('last_name_is_required'),

  otherTitle: yup.string()
    .when('titleId', {
      is: '24',
      then: (schema) => schema.required('this_field_is_required'),
      otherwise: (schema) => schema.notRequired(),
    }),

  genderId: yup
    .object()
    .required('gender_is_required'),

  dateOfBirth: yup
    .date()
    .required('date_of_birth_is_required'),

  placeOfBirth: yup
    .string()
    .max(50, 'Place of Birth must be at most 50 characters')
    .matches(alphabetRegix, 'invalid_country')
    .required('place_of_birth_is_required'),

  nationalityId: yup
    .object()
    .required('citizenship_is_required'),

  anotherNationalityId: yup
    .array()
    .when('areYouAlsoANationalOfAnotherCountry', {
      is: '1',
      then: (schema) => schema.required('another_nationality_is_required')
        .min(1, 'another_nationality_is_required'),
      otherwise: (schema) => schema.notRequired(),
    }),

  identificationNumber: yup
    .string()
    // .matches(/^\d{10}$/, 'id_number_must_be_ten_digits')
    .required('id_number_is_required'),

  identificationNumberExpiryDate: yup
    .string()
    .required('expiry_date_required'),
  // .required('Identification Number Expiry Date is required'),

  identificationNumberExpiryDateGRG: yup
    .string()
    .required('expiry_date_required'),

  maritalStatusId: yup
    .object()
    .required('marital_status__is_required'),

  noOfDependents: yup
    .number()
    .typeError("invalid_number")
    .integer("invalid_number")
    .min(0, 'no_of_dependents_not_be_negative')
    .max(110, 'no_of_dependents_not_be_exceed_110')
    .required('no_of_dependents_is_required'),

  levelOfEducationId: yup
    .string()
    .required('educational_level_is_required'),

  residenceTypeId: yup
    .string()
    .required('resident_type_is_required'),

  approxNetWorthId: yup
    .object()
    .required('net_worth_is_required'),

  approxAnnualIncomeId: yup
    .object()
    .required('annual_income_is_required'),
});
